import type { ReactNode } from 'react'

export type LandingIconName =
  | 'storefront'
  | 'menu'
  | 'orders'
  | 'bag'
  | 'delivery'
  | 'customers'
  | 'dashboard'
  | 'arrow-right'
  | 'check'
  | 'spark'
  | 'globe'
  | 'lock'

const ICON_PATHS: Record<LandingIconName, ReactNode> = {
  storefront: (
    <>
      <path d="M3 9l1.6-5h14.8L21 9" />
      <path d="M4 9v11h16V9" />
      <path d="M9.5 20v-5.5h5V20" />
      <path d="M3 9a3 3 0 0 0 6 0 3 3 0 0 0 6 0 3 3 0 0 0 6 0" />
    </>
  ),
  menu: (
    <>
      <rect x="4" y="3" width="16" height="18" rx="2" />
      <path d="M8 7.5h8M8 12h8M8 16.5h5" />
    </>
  ),
  orders: (
    <>
      <path d="M7 3h10a1 1 0 0 1 1 1v17l-3-2-3 2-3-2-3 2V4a1 1 0 0 1 1-1Z" />
      <path d="M9.5 8h5M9.5 12h5" />
    </>
  ),
  bag: (
    <>
      <path d="M6 8h12l-1 13H7L6 8Z" />
      <path d="M9 8V6.5a3 3 0 0 1 6 0V8" />
      <path d="M9.5 12.5h5" />
    </>
  ),
  delivery: (
    <>
      <path d="M2.5 6.5h10.5v10H2.5z" />
      <path d="M13 9.5h3.6l3.4 3.4v3.6H13" />
      <circle cx="6.5" cy="18" r="2" />
      <circle cx="17.5" cy="18" r="2" />
    </>
  ),
  customers: (
    <>
      <circle cx="9" cy="7.5" r="3.5" />
      <path d="M2.5 21v-1.5a5 5 0 0 1 5-5h3a5 5 0 0 1 5 5V21" />
      <path d="M16.5 4.4a3.5 3.5 0 0 1 0 6.7" />
      <path d="M18 14.8a5 5 0 0 1 3.5 4.8V21" />
    </>
  ),
  dashboard: (
    <>
      <rect x="3" y="3" width="7.5" height="7.5" rx="1.5" />
      <rect x="13.5" y="3" width="7.5" height="7.5" rx="1.5" />
      <rect x="3" y="13.5" width="7.5" height="7.5" rx="1.5" />
      <rect x="13.5" y="13.5" width="7.5" height="7.5" rx="1.5" />
    </>
  ),
  'arrow-right': <path d="M4.5 12h15M13 5.5l6.5 6.5-6.5 6.5" />,
  check: <path d="M20 6.5 9.5 17 4 11.5" />,
  spark: (
    <>
      <path d="M12 3.5 13.9 9l5.6 2-5.6 2L12 18.5 10.1 13 4.5 11l5.6-2L12 3.5Z" />
      <circle cx="19.5" cy="19" r="1.5" />
    </>
  ),
  globe: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18" />
      <path d="M12 3c2.6 2.5 4 5.6 4 9s-1.4 6.5-4 9c-2.6-2.5-4-5.6-4-9s1.4-6.5 4-9Z" />
    </>
  ),
  lock: (
    <>
      <rect x="4.5" y="10" width="15" height="10.5" rx="2" />
      <path d="M8 10V7.5a4 4 0 0 1 8 0V10" />
    </>
  ),
}

export function LandingIcon({
  name,
  className,
}: {
  name: LandingIconName
  className?: string
}) {
  return (
    <svg
      className={className ? `mf-icon ${className}` : 'mf-icon'}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {ICON_PATHS[name]}
    </svg>
  )
}

export function LandingLogoMark() {
  return (
    <span className="mf-logo-mark" aria-hidden="true">
      <svg viewBox="0 0 32 32" fill="none" focusable="false">
        <path
          d="M16 4.5 18.7 11l6.8 2.4-6.8 2.4L16 22.5l-2.7-6.7L6.5 13.4 13.3 11 16 4.5Z"
          fill="currentColor"
        />
        <circle cx="24.5" cy="23.5" r="2" fill="currentColor" opacity=".72" />
      </svg>
    </span>
  )
}
